import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import { ConditionUnitRangeModel } from '../../../models/conditionUnitRangeModel';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';
import { enumToDropdownArray } from '../../../common/functions/helperFunctions';
import { DropdownModel } from "../../../models/dropdownModel";
import { UserConditionType, ConditionUnitType, GenderType } from '../../../common/enums';

interface IProps {
    saveClick: any,
    cancelClick: any,
    isVisible: boolean,
    currentUnitRange: ConditionUnitRangeModel
}

interface IState {
    unitRange: ConditionUnitRangeModel,
    validationMessage: string,
    filterConditionTypeId: number,
    userConditionDropdown: Array<DropdownModel>,
    conditionTypeDropdown: Array<DropdownModel>,
    selectedType: number,
    genderDropdown: Array<DropdownModel>,
    selectedGender: number
}

class DisposalPlaceAddEditDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            unitRange: props.currentUnitRange,
            validationMessage: '',
            filterConditionTypeId: 0,
            userConditionDropdown: new Array<DropdownModel>(0),
            conditionTypeDropdown: new Array<DropdownModel>(0),
            genderDropdown: new Array<DropdownModel>(0),
            selectedGender: 0,
            selectedType: 0
        };
    }

    componentDidMount() {
        let { currentUnitRange } = this.props;
        let genderSelect = currentUnitRange && currentUnitRange.genderTypeId > 0 ? currentUnitRange.genderTypeId : 0;
        let unitType = currentUnitRange && currentUnitRange.conditionUnitType > 0 ? currentUnitRange.conditionUnitType : 0;
        let conditionType = currentUnitRange && currentUnitRange.userConditionTypeId > 0 ? currentUnitRange.userConditionTypeId : 0;
        const firstItem: Array<DropdownModel> = [{ label: 'Select', value: -1 }];
        this.setState({
            userConditionDropdown: firstItem.concat(enumToDropdownArray(UserConditionType)),
            conditionTypeDropdown: firstItem.concat(enumToDropdownArray(ConditionUnitType)),
            genderDropdown: firstItem.concat(enumToDropdownArray(GenderType)),
            filterConditionTypeId: conditionType,
            selectedGender: genderSelect,
            selectedType: unitType
        });
    }

    handleChange = (key, value) => {
        const unitRange: ConditionUnitRangeModel = { ...this.state.unitRange };
        unitRange[key] = value;
        this.setState({ unitRange: { ...unitRange } });
    };

    isValidAddEditForm() {
        let message = '';
        if (!this.state.unitRange.minValue && !this.state.unitRange.maxValue) {
            message += "Min value or max value must be entered. <br />";
        }

        if (this.state.unitRange.minValue && parseFloat(this.state.unitRange.minValue) < 0) {
            message += "Min value can not be negative. <br />";
        }

        if (this.state.unitRange.maxValue && parseFloat(this.state.unitRange.maxValue) < 0) {
            message += "Max value can not be negative. <br />";
        }

        if (this.state.unitRange.minAge && this.state.unitRange.minAge < 0) {
            message += "Min age can not be negative. <br />";
        }

        if (this.state.unitRange.maxAge && this.state.unitRange.maxAge < 0) {
            message += "Max age can not be negative. <br />";
        }

        this.setState({
            validationMessage: message
        });

        return message == '';
    }

    handleSaveButton = (event) => {
        event.preventDefault();
        if (!this.isValidAddEditForm()) return;

        const unitRange = { ...this.state.unitRange };
        if (this.state.selectedGender && this.state.selectedGender > 0) {
            unitRange.genderTypeId = this.state.selectedGender;
        }
        if (this.state.filterConditionTypeId && this.state.filterConditionTypeId > 0) {
            unitRange.userConditionTypeId = this.state.filterConditionTypeId;
        }
        if (this.state.selectedType && this.state.selectedType > 0) {
            unitRange.conditionUnitType = this.state.selectedType;
        }
        this.props.saveClick(unitRange, true);
    }

    handleCancelButton = () => {
        this.props.cancelClick();
    }

    handleDropDownChange = (value) => {
        this.setState({ filterConditionTypeId: value });
    }

    handleTypeDropDownChange = (value) => {
        this.setState({ selectedType: value });
    }

    handleGenderDropDownChange = (value) => {
        this.setState({ selectedGender: value });
    }

    public render() {

        const { unitRange, filterConditionTypeId, userConditionDropdown, conditionTypeDropdown, genderDropdown, selectedGender, selectedType } = this.state;
        const size: number = 10;

        let header = 'Condition unit range';

        return (
            <>
                <Dialog header={header} responsive={true} width="80%"
                    modal={true}
                    visible={this.props.isVisible}
                    onHide={this.handleCancelButton}
                    footer={
                        <div>
                            <Button label="Save" icon="pi pi-save" onClick={(e) => this.handleSaveButton(e)} className="p-button-raised"
                                disabled={(!unitRange.minValue && !unitRange.maxValue) || !filterConditionTypeId || !selectedType || filterConditionTypeId <= 0 || selectedType <= 0} />
                            <Button label="Cancel" icon="pi pi-times" onClick={this.handleCancelButton} className="p-button-secondary p-button-raised" />
                        </div>}
                >
                    <div style={{ minHeight: '350px', maxHeight: '450px' }}>
                        {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
                        <div className="p-grid p-fluid">
                            <div className="p-col-12 p-md-3">
                                <label>User condition type:</label>
                                <Dropdown
                                    value={filterConditionTypeId ? filterConditionTypeId : -1}
                                    options={userConditionDropdown}
                                    onChange={(e) => this.handleDropDownChange(e.value)}
                                    style={{ width: '100%' }}
                                />
                            </div>
                            <div className="p-col-12 p-md-3">
                                <label>Condition unit type:</label>
                                <Dropdown
                                    value={selectedType ? selectedType : -1}
                                    options={conditionTypeDropdown}
                                    onChange={(e) => this.handleTypeDropDownChange(e.value)}
                                    style={{ width: '100%' }}
                                />
                            </div>
                            <div className="p-col-12 p-md-3">
                                <label>Min value:</label>
                                <InputText
                                    keyfilter="num"
                                    name="minValue"
                                    onChange={(e) => this.handleChange('minValue', e.target['value'])}
                                    value={unitRange && unitRange.minValue ? unitRange.minValue : ""}
                                />
                            </div>
                            <div className="p-col-12 p-md-3">
                                <label>Max value:</label>
                                <InputText
                                    keyfilter="num"
                                    name="maxValue"
                                    onChange={(e) => this.handleChange('maxValue', e.target['value'])}
                                    value={unitRange && unitRange.maxValue ? unitRange.maxValue : ""}
                                />
                            </div>
                            <div className="p-col-12 p-md-3">
                                <label>Gender:</label>
                                <Dropdown
                                    value={selectedGender ? selectedGender : -1}
                                    options={genderDropdown}
                                    onChange={(e) => this.handleGenderDropDownChange(e.value)}
                                    style={{ width: '100%' }}
                                />
                            </div>
                            <div className="p-col-12 p-md-3">
                                <label>Min age:</label>
                                <InputText
                                    keyfilter="num"
                                    name="minAge"
                                    onChange={(e) => this.handleChange('minAge', e.target['value'])}
                                    value={unitRange && unitRange.minAge ? unitRange.minAge : ""}
                                />
                            </div>
                            <div className="p-col-12 p-md-3">
                                <label>Max age:</label>
                                <InputText
                                    keyfilter="num"
                                    name="maxAge"
                                    onChange={(e) => this.handleChange('maxAge', e.target['value'])}
                                    value={unitRange && unitRange.maxAge ? unitRange.maxAge : ""}
                                />
                            </div>
                        </div>
                    </div>
                </Dialog >
            </>
        )
    }
}

export default DisposalPlaceAddEditDialog;